import React from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer, // Import ResponsiveContainer
} from "recharts";
import "../GuruBarChart/GuruBarChart.css";

const data = [
  { name: "2013Q2", shares: 0, price: 20 },
  { name: "2013Q4", shares: 500000, price: 19 },
  { name: "2014Q2", shares: 800000, price: 21 },
  { name: "2014Q4", shares: 1200000, price: 23 },
  { name: "2015Q2", shares: 1400000, price: 26 },
  { name: "2015Q4", shares: 1600000, price: 29 },
  { name: "2016Q2", shares: 1800000, price: 35 },
  { name: "2016Q4", shares: 2000000, price: 40 },
  { name: "2017Q2", shares: 2200000, price: 50 },
  { name: "2017Q4", shares: 2400000, price: 55 },
  { name: "2018Q2", shares: 2600000, price: 60 },
  { name: "2018Q4", shares: 2800000, price: 70 },
  { name: "2019Q2", shares: 2500000, price: 65 },
  { name: "2019Q4", shares: 2700000, price: 75 },
  { name: "2020Q2", shares: 2200000, price: 60 },
  { name: "2020Q4", shares: 2400000, price: 80 },
  { name: "2021Q2", shares: 3000000, price: 90 },
  { name: "2021Q4", shares: 3100000, price: 100 },
  { name: "2022Q2", shares: 4600000, price: 110 },
  { name: "2022Q4", shares: 4300000, price: 105 },
  { name: "2023Q2", shares: 2900000, price: 95 },
  { name: "2023Q4", shares: 1800000, price: 100 },
  { name: "2024Q2", shares: 1200000, price: 150 },
];

const GuruBarChart = () => {
  return (
    <div className="gurubarchart-container">
      <h3 style={{ textAlign: "center", marginBottom: "10px" }}>
        Ron Baron TSM ($202.22) Holding Chart
      </h3>
      {/* ResponsiveContainer wraps the chart */}
      <ResponsiveContainer width="100%" height={450}>
        <ComposedChart
          data={data}
          margin={{ top: 20, right: 30, left: 30, bottom: 5 }}
        >
          {/* Grid and Axis */}
          <CartesianGrid
            stroke="#e8e8e8"
            strokeDasharray="dashLength spaceLength"
            vertical={false}
          />
          <XAxis
            dataKey="name"
            angle={-45}
            textAnchor="end"
            interval={0}
            height={60}
          />
          <YAxis
            yAxisId="left"
            label={{
              value: "Quarterly Average Price ($)",
              angle: -90,
              position: "insideLeft",
              dy: 90, // Center alignment
            }}
          />

          <YAxis
            yAxisId="right"
            orientation="right"
            label={{
              value: "No. of Shares at Quarter End",
              angle: 90,
              position: "insideRight",
              offset: 0, // Margin adjustment
              dy: 90, // Center alignment
            }}
            tickFormatter={(value) => `${value / 1000000}m`} // Convert to millions and append "m"
          />

          {/* Tooltips and Legend */}
          <Tooltip />
          <Legend
            verticalAlign="top"
            align="center"
            iconType="circle"
            wrapperStyle={{ marginBottom: 0 }} // Adds bottom margin
            payload={[
              {
                value: "No. of Shares at Quarter End",
                type: "circle",
                color: "#4CAF50",
              },
              {
                value: "Quarterly Average Price ($)",
                type: "line",
                color: "#007bff",
              },
            ]}
          />

          {/* Bars and Lines */}
          <Bar
            yAxisId="right"
            dataKey="shares"
            fill="#4CAF50"
            barSize={20}
            name="No. of Shares at Quarter End"
          />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="price"
            stroke="#007bff"
            strokeWidth={3}
            name="Quarterly Average Price ($)"
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GuruBarChart;
